import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b8b36dc&scoped=true"
import script from "./placeReactivateSubscription.js?vue&type=script&lang=js&external"
export * from "./placeReactivateSubscription.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=5b8b36dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b36dc",
  null
  
)

export default component.exports